import { Navigate, Outlet, createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import NavSidebar from './components/Sidebar/NavSidebar';
import ConversationList from './components/ConversationList/ConversationList';
import ChatArea from './components/ChatArea/ChatArea';
import CrmPanel from './components/CrmPanel/CrmPanel';
import TasksView from './components/TasksView/TasksView';
import CustomersView from './components/CustomersView/CustomersView';
import AnalyticsView from './components/AnalyticsView/AnalyticsView';
import SettingsView from './components/SettingsView/SettingsView';
import ChannelSettingsView from './components/ChannelSettingsView/ChannelSettingsView';

function MessagesPage() {
  return (
    <>
      <ConversationList />
      <ChatArea />
      <CrmPanel />
    </>
  );
}

function SeemeLayout({ onLogout }) {
  return (
    <div className="app-shell">
      <NavSidebar onLogout={onLogout} />
      <Outlet />
    </div>
  );
}

export function createSeemeRouter({ onLogout }) {
  const rootRoute = createRootRoute({
    component: () => <SeemeLayout onLogout={onLogout} />,
    notFoundComponent: () => <Navigate to="/messages" replace />,
  });

  const indexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    component: MessagesPage,
  });

  const messagesRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/messages',
    component: MessagesPage,
  });

  const customersRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/customers',
    component: CustomersView,
  });

  const tasksRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/tasks',
    component: TasksView,
  });

  const analyticsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/analytics',
    component: AnalyticsView,
  });

  const channelsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/channels',
    component: ChannelSettingsView,
  });

  const settingsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/settings',
    component: SettingsView,
  });

  const routeTree = rootRoute.addChildren([
    indexRoute,
    messagesRoute,
    customersRoute,
    tasksRoute,
    analyticsRoute,
    channelsRoute,
    settingsRoute,
  ]);

  return createRouter({ routeTree });
}
